import { useState } from "react";
import PropTypes from "prop-types";
import { resolveMediaSources } from "./lib/resolve-media-sources";
import styles from "./styles/media.module.css";
import { Caption } from "./Caption";

export function Media({ src, title, index }) {
  const [showCaption, setShowCaption] = useState(false);

  const handleShowCaption = (value) => {
    setShowCaption(value);
  };

  return (
    <div
      onMouseEnter={() => handleShowCaption(true)}
      onMouseLeave={() => handleShowCaption(false)}
      className={styles.mediaContainer}
    >
      {resolveMediaSources(src, title, index)}
      <Caption show={showCaption} text={src.alt} />
    </div>
  );
}

Media.propTypes = {
  src: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};
